import { Services, Types } from "@sendum/core";
import { Action, ThunkAction } from "@reduxjs/toolkit";
import { AnyAction } from "redux";
import { toast } from "react-hot-toast";

import { DispatchAction, SendumSupportRootState } from "./SendumSupportStore";
import { ISendumSupportState } from "./SendumSupportReducer";

export enum SendumSupportActionTypes {
	RESET_STATE,
	END_INITIAL_LOADING,
	SET_ERROR,
	SET_LOADING,
	SET_ACCOUNTS,
	SET_USERS,
}

export const resetState = (): DispatchAction => ({
	type: SendumSupportActionTypes.RESET_STATE,
	payload: {},
});

export const endInitialLoading = (): DispatchAction => ({
	type: SendumSupportActionTypes.END_INITIAL_LOADING,
	payload: {},
});

export const setError = (error: Error): DispatchAction => ({
	type: SendumSupportActionTypes.SET_ERROR,
	payload: {
		error,
	},
});

export const setLoading = (isLoading: boolean): DispatchAction => ({
	type: SendumSupportActionTypes.SET_LOADING,
	payload: {
		isLoading,
	},
});

export const setAccounts = (accounts: Types.Account[]): DispatchAction => ({
	type: SendumSupportActionTypes.SET_ACCOUNTS,
	payload: {
		accounts,
	},
});

export const setUsers = (users: Types.User[]): DispatchAction => ({
	type: SendumSupportActionTypes.SET_USERS,
	payload: {
		users,
	},
});

export const loadData = (): ThunkAction<void, SendumSupportRootState, null, Action<string>> => async (dispatch, getState) => {
	const state: ISendumSupportState = getState().SendumSupport;

	if (state.isLoading) {
		return;
	}

	await dispatch(setLoading(true) as unknown as AnyAction);

	try {
		const accounts = await Services.API.SendumApi.getSupportAccountList();
		const users = await Services.API.SendumApi.getSupportUserList();
		await dispatch(setAccounts(accounts));
		await dispatch(setUsers(users));
		await dispatch(endInitialLoading());
		await dispatch(setLoading(false));
	} catch (error) {
		toast.error((error as Error).message);
		await dispatch(endInitialLoading());
		await dispatch(setLoading(false));
		await dispatch(setError(error as Error));
	}
};
